import { useSelector } from 'react-redux'
import AnimatedLoader from '../../../shared_components/AnimatedLoader'
import {
  selectCurrentSeason,
  selectPastSeasons,
} from '../../../modules/seasons/selectors'
import Toggler from '../../../shared_components/Library/Toggler'
import { useHistory, useLocation } from 'react-router-dom'
import { useShouldShowForThreshold } from '../../../theme'

export default function SeasonToggler() {
  const currentSeason = useSelector(selectCurrentSeason)
  const pastSeasons = useSelector(selectPastSeasons)

  const { name: currentSeasonName } = currentSeason
  const location = useLocation()
  const history = useHistory()

  const isPreviousSeasons = location.pathname.includes('previous')

  function navigateToCurrentSeason() {
    history.push('/season')
  }

  function navigateToPreviousSeasons() {
    history.push('/season/previous')
  }

  const isAtLeastMediumDisplaySize = useShouldShowForThreshold('medium')

  if (!currentSeason) return <AnimatedLoader onlyWhite />

  const buttons = [
    {
      name: currentSeasonName,
      onClick: navigateToCurrentSeason,
      isActive: !isPreviousSeasons,
    },
    {
      name: `Past ${isAtLeastMediumDisplaySize ? 'seasons' : ''}`,
      onClick: navigateToPreviousSeasons,
      isActive: isPreviousSeasons,
      disabled: !pastSeasons.length,
    },
  ]

  if (!pastSeasons.length) return <></>

  return <Toggler buttons={buttons} />
}
